export const ROUTES = {
    HOMEPAGE_ROUTE: '/',
    DASHBOARD_PAGE_ROUTE: '/dashboard',
    SIGN_UP_ROUTE: '/sign-up',
    COMPANY_PROFILE_ROUTE: '/company-profile',
    EDIT_COMPANY_PROFILE_ROUTE: '/edit-company-profile',
    DASHBOARD_EMPTY_ROUTE: '/dashboard-unaccess',
    PRIVACY_ROUTE: '/privacy',
    TERMS_SERVICE_ROUTE: '/terms-service',
    ADMIN_USER_MANAGEMENT: '/adminUsers',
    ADMIN_DASHBOARD: '/adminDashboard',
    ADMIN_TIER_MANAGEMENT: '/adminPlans',
    ADMIN_ANALYTICS: '/adminAnalytics',
    CHAT_PAGE_ROUTE: '/chat',
    JOB_DESCRIPTION: '/job-description',
    IDEALIZE_CANDIDATE_PAGE: '/idealize-candidate',
    QUALIFIED_CANDIDATES_PAGE: '/qualified-candidates',
    OUTREACH_PAGE: '/outreach',
    JOB_DESCRIPTION_SUMMARY: '/job-description-summary',
    CANDIDATE_SELECTION: '/candidate-selection',
    PRICING_PAGE_ROUTE: '/pricing',
    CONTACT_US_TO_UPGRADE_ROUTE: '/contact-us-to-upgrade',
};
